import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';
import { Error, CustomHttpErrorResponse } from '../../../common/constants/error';
import { NotificationService } from '../../../common';
import { AnnouncementsInitialState, AnnouncementsLoad } from './announcements.actions';
import { AnnouncementsService } from './announcements.service';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AnnouncementStateModel {
  announcement: string;
  loaded: boolean;
}

const initialState: AnnouncementStateModel = {
  announcement: '',
  loaded: false,
};

@State<AnnouncementStateModel>({
  name: 'Announcements',
  defaults: initialState,
})
@Injectable()
export class AnnouncementState {
  constructor(private announcementsService: AnnouncementsService, private notificationService: NotificationService) {}

  @Selector()
  static getLoaded(state: AnnouncementStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getAnnouncement(state: AnnouncementStateModel): string {
    return state.announcement;
  }

  @Action(AnnouncementsLoad)
  getAnnouncement(ctx: StateContext<AnnouncementStateModel>): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.announcementsService.getAnnouncement().pipe(
      take(1),
      map((returnData: string) => {
        ctx.patchState({ announcement: returnData, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AnnouncementsInitialState)
  setInitialState(ctx: StateContext<AnnouncementStateModel>): void {
    ctx.setState(initialState);
  }
}
